import { Adresse } from './adresse';

export class Entreprise {
    nom: string;

    rue: string;
    codePostal: string;
    ville: string;
    
    telephone: string;
    mail: string;

    constructor() {
    }
}